<script lang="ts">

import SmuiButton, { Label as SmuiLabel, Icon as ButtonIcon } from '@smui/button/styled';
import { namesStore } from '../stores/segmentList';

    let names: string[] = [];

    // Subscribe to the store to get the 'names' value
    namesStore.subscribe((value) => {
        if (Array.isArray(value)) {
            names = value; 
        }
    });

    export async function printCsv(): Promise<void> {
        try {
            if (names && Array.isArray(names)) {
                
                let csvContent = 'Name\n';  // Add headers
                names.forEach(name => {
                    csvContent += `${name}\n`;  // Add each name in a new line
                });

                const blob = new Blob([csvContent], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = 'segments.csv';
                a.click();  

                // Cleanup 
                window.URL.revokeObjectURL(url);
            } else {
                console.error('No valid names data found');
            }
        } catch (error) {
            console.error('Error generating CSV', error);
        }
    };

</script>

		<SmuiButton type="submit" variant="raised" on:click={printCsv}>
			<ButtonIcon class="material-icons">listalt</ButtonIcon>
			<SmuiLabel>Export segments CSV</SmuiLabel>
		</SmuiButton>
		